import { smallTimeOptions } from 'assets/styles/constants';
import { constants } from 'config/constants';
import { uniqBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { inventoryActions } from 'reduxStore/inventory/slice';
import { InventoryTTLockActions } from 'zComponents/atoms';
import { AssignInventoryAssets, EditDeviceLocationModal, UnassignInventoryAssets } from 'zComponents/molecules';
import { Button, Col, Input, Row, Table } from 'zui/Antd';

const { Search } = Input;

const InventoryGatewaysTable = ({ workspaces }) => {
	//Hooks
	const dispatch = useDispatch();

	//Redux state
	const { gateways: inventoryGateways } = useSelector((state) => state.Inventory);

	//Local state
	const [filteredData, setFilteredData] = useState([]);
	const [filteredInfo, setFilteredInfo] = useState({});
	const [selectedInventoryUIDs, setSelectedInventoryUIDs] = useState([]);
	const [selectedDevice, setSelectedDevice] = useState({});
	const [openAssignModal, setOpenAssignModal] = useState(false);
	const [visibleEditLocation, setVisibleEditLocation] = useState(false);
	const [openUnassignModal, setOpenUnassignModal] = useState(false);

	useEffect(() => {
		setFilteredData(inventoryGateways);
	}, [inventoryGateways]);

	const columns = [
		{
			title: 'ID',
			dataIndex: 'gatewayID',
			key: 'gatewayID',
			fixed: 'left',
			ellipsis: true,
			width: 70,
			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: gateway['gatewayID'],
						value: gateway['gatewayID']
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => record['gatewayID'] === value,
			filterSearch: true,
			filteredValue: filteredInfo['gatewayID'] || null
		},
		{
			title: 'Asset ID',
			dataIndex: 'assetID',
			key: 'assetID',
			ellipsis: true,
			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: gateway['assetID'],
						value: gateway['assetID']
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => record['assetID'] === value,
			filterSearch: true,
			filteredValue: filteredInfo['assetID'] || null
		},
		{
			title: 'Name',
			dataIndex: 'gateway Name',
			key: 'gateway Name',
			ellipsis: true,
			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: gateway['gateway Name'],
						value: gateway['gateway Name']
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => record['gateway Name'] === value,
			filterSearch: true,
			filteredValue: filteredInfo['gateway Name'] || null
		},
		{
			title: 'Mac',
			dataIndex: 'gateway Mac',
			key: 'gateway Mac',
			ellipsis: true,

			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: gateway['gateway Mac'],
						value: gateway['gateway Mac']
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => record['gateway Mac'] === value,
			filterSearch: true,
			filteredValue: filteredInfo['gateway Mac'] || null
		},

		{
			title: 'Serial Number',
			dataIndex: 'serial Number',
			key: 'serial Number',

			ellipsis: true,
			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: gateway['serial Number'],
						value: gateway['serial Number']
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => record['serial Number'] === value,
			filterSearch: true,
			filteredValue: filteredInfo['serial Number'] || null
		},

		{
			title: 'Wifi Name',
			dataIndex: 'wifi Network Name',
			key: 'wifi Network Name',

			ellipsis: true,
			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: gateway['wifi Network Name'],
						value: gateway['wifi Network Name']
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => record['wifi Network Name'] === value,
			filterSearch: true,
			filteredValue: filteredInfo['wifi Network Name'] || null
		},
		{
			title: 'Is Online',
			dataIndex: 'is Online',
			key: 'is Online',
			ellipsis: true,
			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: gateway['is Online'],
						value: gateway['is Online']
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => record['is Online'] === value,
			filterSearch: true,
			filteredValue: filteredInfo['is Online'] || null
		},

		{
			title: 'Inventory ID',
			dataIndex: 'inventoryUID',
			key: 'inventoryUID',

			ellipsis: true,
			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: gateway['inventoryUID'],
						value: gateway['inventoryUID']
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => record['inventoryUID'] === value,
			filterSearch: true,
			filteredValue: filteredInfo['inventoryUID'] || null
		},
		{
			title: 'Number of Locks',
			dataIndex: 'number Of Locks',
			key: 'number Of Locks',
			ellipsis: true,
			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: gateway['number Of Locks'],
						value: gateway['number Of Locks']
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => record['number Of Locks'] === value,
			filterSearch: true,
			filteredValue: filteredInfo['number Of Locks'] || null
		},
		{
			title: 'Date Added',
			dataIndex: 'addedOn',
			key: 'addedOn',
			render: (text) => new Date(text).toLocaleString('en-AU', smallTimeOptions),
			ellipsis: true,
			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: new Date(gateway.addedOn).toLocaleString('en-AU', smallTimeOptions),
						value: new Date(gateway.addedOn).toLocaleString('en-AU', smallTimeOptions)
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => new Date(record.addedOn).toLocaleString('en-AU', smallTimeOptions) === value,
			filterSearch: true,
			filteredValue: filteredInfo.addedOn || null
		},
		{
			title: 'Workspace',
			dataIndex: 'orgName',
			key: 'orgName',
			ellipsis: true,
			fixed: 'right',
			filters: uniqBy(
				inventoryGateways.map((gateway) => {
					return {
						text: gateway['orgName'],
						value: gateway['orgName']
					};
				}),
				'text'
			),
			filterMode: 'menu',
			onFilter: (value, record) => record['orgName'] === value,
			filterSearch: true,
			width: 120,
			filteredValue: filteredInfo['orgName'] || null
		},
		{
			title: 'Actions',
			dataIndex: '',
			key: 'actions',
			fixed: 'right',
			width: 250,
			render: (text, record) => (
				<InventoryTTLockActions
					record={record}
					selectedInventoryUIDs={selectedInventoryUIDs}
					setSelectedInventoryUIDs={setSelectedInventoryUIDs}
					setSelectedDevice={setSelectedDevice}
					setVisibleEditLocation={setVisibleEditLocation}
					setOpenAssignModal={setOpenAssignModal}
					setOpenUnassignModal={setOpenUnassignModal}
				/>
			)
		}
	];

	const clearFilters = () => {
		setFilteredInfo({});
		setFilteredData(inventoryGateways);
	};

	const handleSearch = (query, array) => {
		const searchResult = array.filter(
			(object) =>
				object['gateway Name'].toLowerCase().includes(query.toLowerCase()) ||
				object['inventoryName'].toLowerCase().includes(query.toLowerCase()) ||
				object['gateway Mac'].toLowerCase().includes(query.toLowerCase()) ||
				object['gatewayID'].toString().toLowerCase().includes(query.toLowerCase())
		);
		setFilteredData(searchResult);
	};
	const handleChange = (_pagination, filters) => {
		setFilteredInfo(filters);
	};
	return (
		<div style={{ overflow: 'hidden', padding: '0px 10px 10px 10px' }}>
			<Row justify='start'>
				<Col lg={24} md={24} sm={24} xs={24}>
					<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
						<Button size={'small'} onClick={clearFilters}>
							Clear Filter(s)
						</Button>
					</div>
					<Search
						style={{ marginBottom: '10px' }}
						placeholder='Search Gateway Name, ID Or Mac Address'
						enterButton='Search'
						loading={false}
						onChange={(e) => {
							handleSearch(e.target.value, inventoryGateways);
						}}
						onSearch={(query) => {
							handleSearch(query, inventoryGateways);
						}}
					/>
				</Col>
			</Row>
			<Row gutter={24} justify='start'>
				<Col lg={24} md={24} sm={24} xs={24}>
					<Table
						rowKey='inventoryUID'
						columns={columns}
						pageSize={500}
						dataSource={filteredData}
						onChange={handleChange}
						scroll={{ x: 1000 }}
						virtual
						rowSelection={{
							selectedRowKeys: selectedInventoryUIDs.map((d) => d.inventoryUID),
							onChange: (selectedRowKeys, selectedRows) => {
								const firstSelected = selectedRows[0];
								if (!firstSelected) return;

								const firstIsAssigned = !!firstSelected.orgOrgID;

								const filteredRows = selectedRows.filter((row) => !!row.orgOrgID === firstIsAssigned);

								const inventoryDevices = filteredRows.map((row) => ({
									inventoryUID: row.inventoryUID,
									deviceID: row.assetID || null,
									orgID: row.orgOrgID || null,
									name: row.inventoryName
								}));

								setSelectedInventoryUIDs(inventoryDevices);
							},
							getCheckboxProps: (record) => {
								const isAssigned = !!record.orgOrgID;
								const isLocked =
									selectedInventoryUIDs.length > 0 && !!selectedInventoryUIDs[0].orgID !== isAssigned;

								return {
									disabled: !record.inventoryUID || isLocked
								};
							}
						}}
						onRow={(record) => ({
							onClick: () => {
								setSelectedInventoryUIDs((prev) => {
									const exists = prev.some((item) => item.inventoryUID === record.inventoryUID);

									// If already exists, remove it
									if (exists) {
										return prev.filter((item) => item.inventoryUID !== record.inventoryUID);
									}

									// If it's the first selected, simply add it
									if (prev.length === 0) {
										return [
											{
												inventoryUID: record.inventoryUID,
												deviceID: record.assetID || null,
												orgID: record.orgOrgID || null,
												name: record.inventoryName
											}
										];
									}

									// If there are selected, validate compatibility (all must have or not have orgOrgID)
									const firstIsAssigned = !!prev[0].orgID;
									const currentIsAssigned = !!record.orgOrgID;

									if (firstIsAssigned === currentIsAssigned) {
										// Add only if the state matches
										return [
											...prev,
											{
												inventoryUID: record.inventoryUID,
												deviceID: record.assetID || null,
												orgID: record.orgOrgID || null,
												name: record.inventoryName
											}
										];
									}

									// If it doesn't match, ignore
									return prev;
								});
							}
						})}
					/>
				</Col>
			</Row>

			<AssignInventoryAssets
				workspaces={workspaces}
				devices={selectedInventoryUIDs}
				setDevices={setSelectedInventoryUIDs}
				open={openAssignModal}
				setOpen={setOpenAssignModal}
				refetch={() => dispatch(inventoryActions.loadInventoryGateways())}
				categories={[
					{
						categoryID: constants.SMART_GATEWAYS,
						name: 'Smart Gateways'
					}
				]}
				platform='TTlock'
				type='Gateway'
			>
				<div />
			</AssignInventoryAssets>

			<UnassignInventoryAssets
				devices={selectedInventoryUIDs}
				setDevices={setSelectedInventoryUIDs}
				open={openUnassignModal}
				setOpen={setOpenUnassignModal}
				refetch={() => dispatch(inventoryActions.loadInventoryGateways())}
				platform='TTlock'
				type='Gateway'
			>
				<div />
			</UnassignInventoryAssets>

			<EditDeviceLocationModal
				editVisible={visibleEditLocation}
				setEditVisible={setVisibleEditLocation}
				deviceID={selectedDevice.deviceID}
				orgID={selectedDevice.orgID}
				orgName={selectedDevice.orgName}
			>
				<div />
			</EditDeviceLocationModal>
		</div>
	);
};

export default InventoryGatewaysTable;
